import { MutableRefObject, useEffect, useRef } from 'react';
import { useHover } from './useHover';

/**
 * Hook for calling callback after some element has been hovered or has been and now is not
 *
 * @param callback - callback called after hover state on ref is changed
 * @param ref - reference to the DOM element that should be handled
 */
export const useHoverEffect = <T extends HTMLElement>(
    callback: (hovered: boolean) => void,
    ref: MutableRefObject<T | null>
) => {
    const enabled = useRef(false);

    const hover = useHover(ref);

    useEffect(() => {
        if (!enabled.current) {
            // do not call onMouseOut function when `hover` has not been modified yet
            enabled.current = true;
        } else {
            callback(hover);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hover]);
};
